import DriveApi from "./api";

interface ICallableConnection {
    call: (methodName: string, methodParams?: any, secure?: boolean, timeout?: number) => {
        beginInvoke: (successCallback: any, errorCallback: any) => void;
    };
}

export default class MyGeotabConnectionAdapter implements ICallableConnection {
    private readonly api: DriveApi;

    constructor(api: DriveApi) {
        this.api = api;
    }

    call(methodName: string, methodArguments: {}): any {
        const api = this.api;

        return {
            beginInvoke(successCallback: any, errorCallback: any): void {
                api.call(methodName, methodArguments, successCallback, errorCallback);
            }
        };
    }
}
